export default __webpack_public_path__ + "static/KidsHomepageBanner-f8bd53e5123bf99b3454c14e4a7122b0.png";